import { CardType } from '../types/CardList';
import uzcard from '/assets/uzcard.png';
import humo from '/assets/humo.png';
import mastercard from '/assets/mastercard.png';
import visa from '/assets/visa.png';

export const cardImg = (type: CardType) => {
  switch (type) {
    case CardType.UZCARD:
      return uzcard;
    case CardType.HUMO:
      return humo;
    case CardType.MASTERCARD:
      return mastercard;
    case CardType.VISA:
      return visa;
    default:
      return uzcard;
  }
};
